import * as Cookies from "js-cookie";
var DEFAULT_LANGUAGE = "en";
var supportedLanguages = [
    "en",
    "de" /*, // German
    'es', // Spanish
    'pt-BR', //Brazilian Portugues
    'fr', // French
    'jp' // Japanese
    */,
];
// In which syntax the languageString is in? See for more:
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept-Language
function isAnySyntax(languageString) {
    return languageString === "*";
}
function isLanguageSyntax(languageString) {
    return !/-/.test(languageString);
}
function isLocaleSyntax(languageString) {
    return /-/.test(languageString);
}
/*
 * Extract language (e.g. 'en') from local string, like en-US
 */
function extractLanguageFromLocale(locale) {
    return locale.replace(/-[a-z]{2,3}/i, "");
}
/*
 * Extract preffered languages from Accepts-Language content
 */
function extractLanguagesFromHeader(acceptsLanguageString) {
    return acceptsLanguageString
        .replace(/q=[0-9\.]+/g, "") // Remove quality values
        .split(/,[\s]?/); // Turn string to array of language codes
}
function isSupported(language) {
    return supportedLanguages.includes(language);
}
function extractLanguage(acceptsLanguageString) {
    if (!acceptsLanguageString)
        return DEFAULT_LANGUAGE;
    var choices = extractLanguagesFromHeader(acceptsLanguageString)
        .map(function (language) {
        // Special case with Brazilian Portugese
        if (language === "pt-BR")
            return language;
        if (isLanguageSyntax(language))
            return language;
        if (isLocaleSyntax(language))
            return extractLanguageFromLocale(language);
    })
        .filter(isSupported);
    var bestChoice = choices[0];
    if (isAnySyntax(bestChoice))
        return DEFAULT_LANGUAGE;
    return bestChoice;
}
export function getLanguage() {
    var cookieValue = Cookies.get("lang");
    return extractLanguage(cookieValue) || DEFAULT_LANGUAGE;
}



//////////////////
// WEBPACK FOOTER
// ./src/internationalization.ts
// module id = 136
// module chunks = 1